import React from 'react';

import LoadingSpinner from '../../util/LoadingSpinner';
import AccessOption from '../ManageRoles/Components/AccessOption';
import HomeOptions from './HomeOptions';
import './optionsList.css';

export default class OptionsList extends React.Component{

    componentDidMount(){
        window.addEventListener('resize', this.onResize)
    }
  
    componentWillUnmount(){
        window.removeEventListener('resize', this.onResize)
    }
  
    onResize = () => this.forceUpdate()
  
    drawOption = (optionKey) => {
        var option = this.props.allOptions[optionKey]
        return (
            <div key={option.title}>
                <AccessOption
                    selected={true}
                    imageScale={0.5}
                    icon={option.icon}
                    title={option.title}
                    onClick={()=>{
                        this.props.onOptionSelected(option)
                    }}
                />
            </div>
        )
    }
   
    render(){
        const state = this.props.machine.state.value
    
        if(state === "Init") return <LoadingSpinner/>
        return Object.keys(HomeOptions.rows).map((sectionTitle)=>{
            return this.renderSection(sectionTitle, HomeOptions.rows[sectionTitle])
        })
    }

    renderSection(title, items){
        var allowedIds = []
        const optionIds = this.props.availableOptions;
        items.forEach((item)=>{
            if(optionIds.includes(item)){
                allowedIds.push(item)
            }
        })

        return (
            <div className="optionsSection" key={title}>
                    <h1 className='sectionTitle'>
                        {title}
                    </h1>
                    <div className='optionItemsContainer'>
                        {
                            allowedIds.map((val) => this.drawOption(val))
                        }
                    </div>
            </div>
        );
    }
}